import background from './background';
import text from './text';
import icon from './icon';

export default {
  background,
  text,
  icon,
};
